import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {
  CreateTelegramAccountParams,
  GetTelegramCodeParams,
  SetTelegramCodeParams,
  TelegramAccount
} from "../types/add-telegram-accounts.types";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../constants/base-url";
import {telegramAccountsResourceType, telegramResourceType} from "../configs/add-telegram-account-config";

@Injectable({
  providedIn: 'root'
})
export class TelegramAccountsApiService {
  private http: HttpClient = inject(HttpClient);

  public getTelegramCode(getTelegramCodeParams: GetTelegramCodeParams): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${telegramResourceType.path}/login/phone`, {}, { params: getTelegramCodeParams });
  }

  public setTelegramCode(setTelegramCodeParams: SetTelegramCodeParams): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${telegramResourceType.path}/login/code`, {}, { params: setTelegramCodeParams });
  }

  public createTelegramAccount(createTelegramAccountParams: CreateTelegramAccountParams): Observable<TelegramAccount> {
    return this.http.post<TelegramAccount>(`${baseUrl}/${telegramAccountsResourceType.path}`, createTelegramAccountParams);
  }
}
